// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

// Vuetify
import { createVuetify, ThemeDefinition } from 'vuetify';
import * as directives from 'vuetify/directives';

const myCustomLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    surface: '#FFF3FC',
    muted: '#E3DDE3',
    'primary-dark': '#4E1248',
    primary: '#710666',
    'primary-lighten-1': '#976A91',
    'primary-lighten-2': '#C1A0BD',
    secondary: '#A6C87B',
    'secondary-lighten-1': '#C0D4A6',
    danger: '#982C2C',
    info: '#32889F',
    success: '#368536',
    warning: '#C7C250',
  },
};

export default createVuetify({
  components: {},
  theme: {
    defaultTheme: 'myCustomLightTheme',
    themes: {
      myCustomLightTheme,
    },
  },
  directives,
});

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
